import { MDSIcon } from "@/mds/components/icon";
import styled from "@emotion/styled";
import { Radio, RadioGroup } from "react-aria-components";

export const StyledRadio = styled(Radio)`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &[data-disabled] {
    cursor: default;
    opacity: 0.5;
  }
`;

export const StyledIndicator = styled.div`
  padding: ${({ theme }) => theme.spacing["2"]};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledRadioGroup = styled(RadioGroup)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["2"]};

  [slot="label"] {
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
    font-size: ${({ theme }) => theme.fontSizes["paragraph-s"]};
    margin-bottom: ${({ theme }) => theme.spacing["1"]};
  }

  [slot="description"] {
    font-size: ${({ theme }) => theme.fontSizes["text-s"]};
    color: ${({ theme }) => theme.colors.text.secondary};
    margin-bottom: ${({ theme }) => theme.spacing["1"]};
  }

  [slot="errorMessage"] {
    font-size: ${({ theme }) => theme.fontSizes["text-s"]};
    color: ${({ theme }) => theme.colors.text.danger};
    margin-top: ${({ theme }) => theme.spacing["1"]};
  }
`;

export const StyledRadioIcon = styled(MDSIcon)`
  .mds-icon {
    transition: all 200ms;
  }
`;
